import { InviteesListCard } from "./InviteesListCard";

export default InviteesListCard;
